/**
 * Main accordion parent block
 */
$('.accordion').each((i, el) => {
	const $accordion = $(el);
	const id = 'accordion-' + Math.random().toString(16).slice(2);

	// Add an ID to the block
	$accordion.attr('id', id);

	// Add the parent block ID to the accordion items so that only one is open at a time
	$accordion.find('.accordion-collapse').attr({
		'data-bs-parent': `#${id}`
	});
});

/**
 * Accordion item blocks
 */
$('.accordion-item').each((i, el) => {
	const $item = $(el);
	const id = 'accordion-item-' + Math.random().toString(16).slice(2);

	// Add attributes to the toggle button
	$item.find('.accordion-button').attr({
		'data-bs-target': `#${id}`,
		'aria-controls': id
	});

	// Add id to the collapse container
	$item.find('.accordion-collapse').attr({
		'id': `${id}`
	});
});

